import React, { useState } from "react";
import { Box } from "@mui/material";
import SideNavbar from "../../../components/sideNavbar";
import Header from "../../../components/header";
import LeadManagement from "./leadManagementSystem/LeadManagementSystem";

const Kanban = () => {
  return (
    <>
      <Box>
        <Box sx={{ ml: { xs: "0px", md: "280px" } }}>
          <SideNavbar />
          <Box sx={{ display: { xs: "none", md: "initial" } }}>
            {/* <Header title={"Lead Pipeline"} /> */}
          </Box>

          <Box
            component="main"
            sx={{
              width: "100%",
            }}
          >
            <LeadManagement />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Kanban;
